import { ChangePasswordModel } from './../../../models/Auth/ChangePasswordModel';
import { LoadingService } from './../../../services/loading.service';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MyErrorStateMatcher } from 'src/app/common/matcher/MyErrorStateMatcher';
import { OnlineAccountValidation } from 'src/app/models/enums/Auth/OnlineAccountValidationEnum';


@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  faTimesCircle = faTimesCircle;
  userEmail: string;
  form: FormGroup;
  submitted: boolean = false;
  success: boolean;
  passwordPattern = '^(?=.*[0-9])(?=.*[!@#$%^&*])[0-9a-zA-Z!@#$%^&*0-9]{8,}$';

  matcher = new MyErrorStateMatcher();
  errorType: OnlineAccountValidation;
  constructor(

    private auth: AuthService,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private router: Router,
    private formBuilder: FormBuilder,
    public translateService: TranslateService,) {

  }

  ngOnInit() {
    this.auth.loggedInUser.subscribe(res => {
      if (res != null) {
        this.userEmail = res.email;
      }

    })
    this.form = new FormGroup({
      OldPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8)
      ]),
      NewPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern("^(?=.*[0-9])(?=.*[!@#$%^&*])[0-9a-zA-Z!@#$%^&*0-9]{8,}$")
      ]),
      ConfirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern("^(?=.*[0-9])(?=.*[!@#$%^&*])[0-9a-zA-Z!@#$%^&*0-9]{8,}$")
        // validator: MustMatch('NewPassword', 'ConfirmPassword')
      ]),


    }, { validators: this.checkPasswords });

  }

  get onlineAccountValidation(){
    return OnlineAccountValidation;
  }

  checkPasswords(group: FormGroup) {
    let pass = group.controls.NewPassword.value;
    let confirmPass = group.controls.ConfirmPassword.value;

    return pass == confirmPass ? null : { notSame: true };

  }

  close() {
    this.dialogRef.close();
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  onSubmit() {


    this.submitted = true;

    if (this.form.invalid) {
      this.validateAllFormFields(this.form);
      return;
    //  this.submitted = false;
    }

    let req: ChangePasswordModel = {
      email: this.userEmail,
      currentPassword: this.form.value["OldPassword"],
      newPassword: this.form.value["NewPassword"]
    }
    this.auth.changePassword(req).subscribe(res => {
      if (res != null && res["success"]) {
        this.success = true;

      }
      else {
        this.success = false;
        this.errorType = OnlineAccountValidation.SomethingWrongHappened;
      }
    }, err => {
      this.success = false;

      if (err.status == 422 && err.error.isServerValidation) {
        const validationCode = err.error.code;
        switch (validationCode) {
          case OnlineAccountValidation.EmailNotFound:
            this.errorType = OnlineAccountValidation.EmailNotFound;
            break;
            case OnlineAccountValidation.InvalidPassword:
              this.errorType=OnlineAccountValidation.InvalidPassword;
              break;
              default:
                this.errorType=OnlineAccountValidation.SomethingWrongHappened;
                break;

        }


      }
    })

  }


}



